exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bibleCloudNotFound[data-v-1415d2c4] {\n  align-items: center;\n  color: #616b7d;\n  display: flex;\n  font-size: 40px;\n  height: 60vh;\n  justify-content: center;\n  text-transform: uppercase;\n}", ""]);

// exports
